export enum VerificationStatus {
  NOT_STARTED = 'NOT_STARTED',
  SUBMITTED = 'SUBMITTED',
  RUNNING = 'RUNNING',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}

export enum VerificationResult {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  REVIEW = 'REVIEW',
  UNKNOWN = 'UNKNOWN',
}

interface CustomerKYXVerificationBase {
  readonly id: string;
  readonly sessionId: string;
  readonly integratorId: string;
  readonly verificationStatus: VerificationStatus;
  readonly verificationResult: VerificationResult;
  readonly createdDate: string;
  readonly createdBy: string;
}

export interface CustomerKYCVerification extends CustomerKYXVerificationBase {
  readonly type: 'INDIVIDUAL';
  readonly firstName: string;
  readonly lastName: string;
}

export interface CustomerKYBVerification extends CustomerKYXVerificationBase {
  readonly type: 'BUSINESS';
  readonly businessName: string;
}

export type CustomerKYXVerification = CustomerKYCVerification | CustomerKYBVerification;
